module.exports = __webpack_public_path__ + "static/media/warning.1644de8c.svg";